
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieCaricamentiDialog extends Serenity.EntityDialog<TipologieCaricamentiRow, any> {
        protected getFormKey() { return TipologieCaricamentiForm.formKey; }
        protected getIdProperty() { return TipologieCaricamentiRow.idProperty; }
        protected getLocalTextPrefix() { return TipologieCaricamentiRow.localTextPrefix; }
        protected getNameProperty() { return TipologieCaricamentiRow.nameProperty; }
        protected getService() { return TipologieCaricamentiService.baseUrl; }
        protected getDeletePermission() { return TipologieCaricamentiRow.deletePermission; }
        protected getInsertPermission() { return TipologieCaricamentiRow.insertPermission; }
        protected getUpdatePermission() { return TipologieCaricamentiRow.updatePermission; }

        protected form = new TipologieCaricamentiForm(this.idPrefix);

    }
}